import { sanitizeUrl } from './UrlSanitizer.js'

// StoreCMSのURL判定仕様に合わせた正規表現
const URL_REGEX = /(https?:\/\/[^\s]+)/g

/**
 * テキストをURL部分とそれ以外に分割し、URLをサニタイズした配列を返す
 *
 * @param {string} rawText - 分割するテキスト
 * @returns {Array<{isUrl: boolean, text: string, href: string|null, key: string}>}
 */
export function splitTextWithUrlParts(rawText) {
  if (!rawText) return []

  const parts = rawText.split(URL_REGEX)

  return parts.map((part, index) => {
    // キャプチャグループ部分が奇数インデックスになる
    const isCandidateUrl = index % 2 === 1

    if (!isCandidateUrl) {
      return { isUrl: false, text: part, href: null, key: index }
    }

    const safeHref = sanitizeUrl(part)
    if (!safeHref) {
      // URLと判定された見た目だが、危険なスキームなどで弾かれた場合は
      // プレーンテキストとして扱う
      return { isUrl: false, text: part, href: null, key: index }
    }

    return { isUrl: true, text: part, href: safeHref, key: index }
  })
}

export default {
  splitTextWithUrlParts
}
